<template>
  <div>
    <div class="centerx">
      <vs-popup
        class="warning-msg popup-close"
        classContent="popup-example"
        :title="null"
        :active.sync="showWarning"
        @close="closedpopup"
        ><div
          style="font-size: 20px; color: rgb(255, 204, 0); margin-left: 10px"
          v-if="warningMessage"
        >
          ⚠ {{ $t("label.warning") }}!!
        </div>
        <div
          style="font-size: 20px; color: orangered; margin-left: 10px"
          v-if="errorText"
        >
          ⛔ Error!!
        </div>

        <div class="font-semibold p-3">
          {{ warningMessage }}
          {{ errorText }}
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
export default {
  name: "validation-popup",
  props: {
    name: String,
    warningPopup: { type: Boolean, default: false },
    warningText: String,
    errorMessage: String,
  },
  data() {
    return { showWarning: false };
  },
  computed: {
    errorText() {
      return this.errorMessage;
    },
    warningMessage() {
      return this.warningText;
    },
  },
  methods: {
    closedpopup() {
      this.$emit("closeWarning");
    },
  },
  components: {},
  watch: {
    warningPopup(val) {
      this.showWarning = val;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/components/vxCard.scss";
::v-deep .vs-popup--close--icon {
  color: red;
}
</style>
